import React from "react";
import Home from "./components/ui/general/Home";
import { Route, Switch, HashRouter as Router } from "react-router-dom";
// import Signup from "./components/ui/auth/Signup"; // Comentado - Registro deshabilitado
import Logout from "./components/ui/auth/Logout";
import NewPassword from "./components/ui/auth/NewPassword";
import ResetPassword from "./components/security/ResetPassword";
import Users from "./components/ui/general/Users";
import Settings from "./components/ui/settings/Settings";
import Security from "./components/ui/settings/Security";
import Roles from "./components/ui/settings/Roles";
import NewRole from "./components/ui/settings/NewRole";
import MediosPublicitarios from "./components/ui/settings/MediosPublicitarios";
import NuevoMedioPublicitario from "./components/ui/settings/NuevoMedioPublicitario";
import ParametrosSistema from "./components/ui/settings/ParametrosSistema";
import ParametrosSuscripcionEpayco from "./components/ui/settings/ParametrosSuscripcionEpayco";
import ParametrosWhatsapp from "./components/ui/settings/ParametrosWhatsapp";
import Aseguradoras from "./components/ui/settings/Aseguradoras";
import NuevaAseguradora from "./components/ui/settings/NuevaAseguradora";
import Convenios from "./components/ui/settings/Convenios";
import NuevoConvenio from "./components/ui/settings/NuevoConvenio";
import PersonalProveedores from "./components/ui/settings/PersonalProveedores";
import Especialidades from "./components/ui/settings/Especialidades";
import NuevaEspecialidad from "./components/ui/settings/NuevaEspecialidad";
import EmpresasAseguradoras from "./components/ui/settings/EmpresasAseguradoras";
import NuevaEmpresa from "./components/ui/settings/NuevaEmpresa";
import UnidadesAtencion from "./components/ui/settings/UnidadesAtencion";
import NuevaUnidadAtencion from "./components/ui/settings/NuevaUnidadAtencion";
import Usuarios from "./components/ui/settings/Usuarios";
import NuevoUsuario from "./components/ui/settings/NuevoUsuario";
import Cargos from "./components/ui/settings/Cargos";
import NuevoCargo from "./components/ui/settings/NuevoCargo";
import TiposContrato from "./components/ui/settings/TiposContrato";
import NuevoTipoContrato from "./components/ui/settings/NuevoTipoContrato";
import Proveedores from "./components/ui/settings/Proveedores";
import NuevoProveedor from "./components/ui/settings/NuevoProveedor";
import UsuariosSispro from "./components/ui/settings/UsuariosSispro";
import NuevoUsuarioSispro from "./components/ui/settings/NuevoUsuarioSispro";
import EditarUsuarioSispro from "./components/ui/settings/Edit/EditarUsuarioSispro";
import AdministrarPlantillas from "./components/ui/settings/AdministrarPlantillas";
import PlantillasFormulas from "./components/ui/settings/PlantillasFormulas";
import NuevaPlantillaFormula from "./components/ui/settings/NuevaPlantillaFormula";
import PlantillasOtrosDocumentos from "./components/ui/settings/PlantillasOtrosDocumentos";
import NuevaPlantillaOtroDocumento from "./components/ui/settings/NuevaPlantillaOtroDocumento";
import PlantillasExamenes from "./components/ui/settings/PlantillasExamenes";
import NuevaPlantillaExamen from "./components/ui/settings/NuevaPlantillaExamen";
import PlantillasRecomendaciones from "./components/ui/settings/PlantillasRecomendaciones";
import NuevaPlantillaRecomendacion from "./components/ui/settings/NuevaPlantillaRecomendacion";
import PlantillasIncapacidades from "./components/ui/settings/PlantillasIncapacidades";
import NuevaPlantillaIncapacidad from "./components/ui/settings/NuevaPlantillaIncapacidad";
import PlantillasEventosAdversos from "./components/ui/settings/PlantillasEventosAdversos";
import NuevaPlantillaEventoAdverso from "./components/ui/settings/NuevaPlantillaEventoAdverso";
import ParametrosInventario from "./components/ui/settings/ParametrosInventario";
import LocalizacionesArticulos from "./components/ui/settings/LocalizacionesArticulos";
import NuevaLocalizacionArticulo from "./components/ui/settings/NuevaLocalizacionArticulo";
import ReferenciasInventario from "./components/ui/settings/ReferenciasInventario";
import NuevaReferenciaInventario from "./components/ui/settings/NuevaReferenciaInventario";
import PlantillasConsentimientos from "./components/ui/settings/PlantillasConsentimientos";
import NuevaPlantillaConsentimiento from "./components/ui/settings/NuevaPlantillaConsentimiento";
import AdministrarTratamientos from "./components/ui/settings/AdministrarTratamientos";
import EspecialidadesReferencia from "./components/ui/settings/EspecialidadesReferencia";
import NuevaEspecialidadReferencia from "./components/ui/settings/NuevaEspecialidadReferencia";
import ParametrosEvolucion from "./components/ui/settings/ParametrosEvolucion";
import NuevoParametroEvolucion from "./components/ui/settings/NuevoParametroEvolucion";
import EditarParametroHistoriaClinica from "./components/ui/settings/Edit/EditarParametroHistoriaClinica";
import ListaPrecios from "./components/ui/settings/ListaPrecios";
import NuevaListaPrecios from "./components/ui/settings/NuevaListaPrecios";
import ListaPreciosConvenio from "./components/ui/settings/ListaPreciosConvenio";
import AdministrarConvenios from "./components/ui/settings/AdministrarConvenios";
import MenuPacientes from "./components/ui/settings/MenuPacientes";
import MenuLaboratorio from "./components/ui/laboratorio/MenuLaboratorio";
import ListarOrdenesLaboratorio from "./components/ui/laboratorio/ListarOrdenesLaboratorio";
import CrearOrdenLaboratorio from "./components/ui/laboratorio/CrearOrdenLaboratorio";
import DetalleOrdenLaboratorio from "./components/ui/laboratorio/DetalleOrdenLaboratorio";
import TiposTrabajoLaboratorio from "./components/ui/laboratorio/TiposTrabajoLaboratorio";
import MaterialesLaboratorio from "./components/ui/laboratorio/MaterialesLaboratorio";
import PlantillasHistoriaClinica from "./components/ui/settings/PlantillasHistoriaClinica";
import AsignarPlantillas from "./components/ui/settings/AsignarPlantillas";
import AgendarPaciente from "./components/ui/paciente/AgendarPaciente";
import ParametrosAgenda from "./components/ui/settings/ParametrosAgenda";
import PlanesAgendamiento from "./components/ui/settings/PlanesAgendamiento";
import PlanAgendamientoForm from "./components/ui/settings/PlanAgendamientoForm";
import PacientePlanesSesiones from "./components/ui/paciente/PacientePlanesSesiones";
import HorarioAtencion from "./components/ui/settings/HorarioAtencion";
import EstadosCita from "./components/ui/settings/EstadosCita";
// NuevoEstadoCita eliminado - estados predeterminados
import ListarPacientes from "./components/ui/paciente/ListarPacientes";
import EstadoCuentaPaciente from "./components/ui/paciente/EstadoCuentaPaciente";
import ListarCitas from "./components/ui/paciente/ListarCitas";
import NewUser from "./components/ui/auth/NewUser";
import ActivateUser from "./components/ui/auth/ActivateUser";
import EditarAseguradora from "./components/ui/settings/Edit/EditarAseguradora";
import EditarEmpresa from "./components/ui/settings/Edit/EditarEmpresa";
import EditarConvenio from "./components/ui/settings/Edit/EditarConvenio";
import EditarParametroEvolucion from "./components/ui/settings/Edit/EditarParametroEvolucion";
import EditarFormulaMedica from "./components/ui/settings/Edit/EditarFormulaMedica";
import EditarOtroDocumento from "./components/ui/settings/Edit/EditarOtroDocumento";
import EditarPlantillaExamenLaboratorio from "./components/ui/settings/Edit/EditarPlantillaExamenLaboratorio";
import EditarPlantillaIncapacidades from "./components/ui/settings/Edit/EditarPlantillaIncapacidades";
import EditarPlantillaEventosAdversos from "./components/ui/settings/Edit/EditarPlantillaEventosAdversos";
import EditarPlantillaConsentimiento from "./components/ui/settings/Edit/EditarPlantillaConsentimiento";
import EditarAreaLocalizacion from "./components/ui/settings/Edit/EditarAreaLocalizacion";
import EditarReferenciaInventario from "./components/ui/settings/Edit/EditarReferenciaInventario";
import EditarEspecialidad from "./components/ui/settings/Edit/EditarEspecialidad";
import EditarProveedor from "./components/ui/settings/Edit/EditarProveedor";
import EditarUnidadAtencion from "./components/ui/settings/Edit/EditarUnidadAtencion";
import EditarCargo from "./components/ui/settings/Edit/EditarCargo";
import EditarTipoContrato from "./components/ui/settings/Edit/EditarTipoContrato";
import EditarListaPrecios from "./components/ui/settings/Edit/EditarListaPrecios";
import EditarEspecialidadReferencia from "./components/ui/settings/Edit/EditarEspecialidadReferencia";
import EditarMedioPublicitario from "./components/ui/settings/Edit/EditarMedioPublicitario";
import EditarEstadoCita from "./components/ui/settings/Edit/EditarEstadoCita";
import Perfil2 from "./components/ui/general/Perfil2";
import SetPassword from "./components/security/SetPassword";
import Loading from "./components/ui/general/Loading";
import ClientForm from "./components/ui/general/ClientForm";
import EditarRol from "./components/ui/settings/Edit/EditarRol";
import EditarPaciente from "./components/ui/paciente/EditarPaciente";
import BloqueosAgenda from "./components/ui/settings/BloqueosAgenda";
import NuevoBloqueo from "./components/ui/settings/NuevoBloqueo";
import AtenderPaciente from "./components/ui/paciente/AtenderPaciente2";
import AyudasDiagnosticasPaciente from "./components/ui/paciente/AyudasDiagnosticasPaciente";
import HistoriaClinicaJsonPage from "./components/ui/paciente/ModalHistoriaClinicaJson";
import EvolucionPaciente from "./components/ui/paciente/ModalEvolucion";
// import EvolucionPaciente from "./components/ui/paciente/EvolucionPaciente";
import ToxinaBotulinica from "./components/ui/paciente/ToxinaBotulinica";
import CuestionarioPaciente1 from "./components/ui/paciente/CuestionarioPaciente1";
import CuestionarioPaciente2 from "./components/ui/paciente/CuestionarioPaciente2";
import CuestionarioPaciente3 from "./components/ui/paciente/CuestionarioPaciente3";
import CuestionarioPaciente4 from "./components/ui/paciente/CuestionarioPaciente4";
import ConfirmacionCuestionario from "./components/ui/paciente/ConfirmacionCuestionario";
import TiemposCita from "./components/ui/settings/TiemposCita";
import NuevoTiempoCita from "./components/ui/settings/NuevoTiempoCita";
import CuentaForm from "./components/ui/general/CuentaForm";
import CambioClave from "./components/ui/general/CambioClave";
//import CrearPaciente from "./components/ui/paciente/CrearPaciente";
import AgendaGeneral from "./components/ui/general/AgendaGeneral";
import AgendaDashboard from "./components/ui/general/AgendaDashboard";
import OtrasPlantillas from "./components/ui/settings/OtrasPlantillas";
import NuevaPlantilla from "./components/ui/settings/NuevaPlantilla";
import Login2 from "./components/ui/auth/Login2";
import EditarPlantillaRecomendaciones from "./components/ui/settings/Edit/EditarPlantillaRecomendaciones";
import EditarBloqueo from "./components/ui/settings/Edit/EditarBloqueo";
import EditarPlantillaOtras from "./components/ui/settings/Edit/EditarPlantillaOtras";
import EditarTiempoCita from "./components/ui/settings/Edit/EditarTiempoCita";
import NuevoPrecioConvenio from "./components/ui/settings/NuevoPrecioConvenio";
import EditarPrecioConvenio from "./components/ui/settings/Edit/EditarPrecioConvenio";
import Estadisticas from "./components/ui/general/Estadisticas";
import EstadisticasContables from "./components/ui/general/EstadisticasContables";
import ReportesAgenda from "./components/ui/general/ReportesAgenda";
import EstadoCuentaReportes from "./components/ui/reportes/EstadoCuentaReportes";
import ReportePacientes from "./components/ui/reportes/ReportePacientes";
import ReporteFacturacion from "./components/ui/reportes/ReporteFacturacion";
import ReporteNotasCredito from "./components/ui/reportes/ReporteNotasCredito";
import ReporteLiquidarProfesional from "./components/ui/reportes/ReporteLiquidarProfesional";
import ListadoLiquidacionProfesional from "./components/ui/reportes/ListadoLiquidacionProfesional";
import ReportePresupuestosAprobados from "./components/ui/reportes/ReportePresupuestosAprobados";
import LibroDiario from "./components/ui/reportes/LibroDiario";
import ReporteFacturasRecibos from "./components/ui/reportes/ReporteFacturasRecibos";
import ReporteDocumentosEgresos from "./components/ui/reportes/ReporteDocumentosEgresos";
import ReporteDocumentosSoporte from "./components/ui/reportes/ReporteDocumentosSoporte";
import ReporteEgresos from "./components/ui/reportes/ReporteEgresos";
import ReporteTratamientosFacturados, { ReporteTratamientosFacturadosPaciente } from "./components/ui/reportes/ReporteTratamientosFacturados";
import ExportarSiigo from "./components/ui/reportes/ExportarSiigo";
import BusquedaCitas from "./components/ui/agenda/BusquedaCitas";

import CitasCanceladas from "./components/ui/estadisticas/Agenda/CitasCanceladas";
import BloqueosUnidades from "./components/ui/settings/BloqueosUnidades";
import ControlAsistencia from "./components/ui/agenda/ControlAsistencia";
import NuevoBloqueoUnidad from "./components/ui/settings/NuevoBloqueoUnidad";
import EditarBloqueoUnidad from "./components/ui/settings/Edit/EditarBloqueoUnidad";
import EstadisticasAgenda from "./components/ui/estadisticas/Agenda/EstadisticasAgenda";
import VistaPorRecursos from "./components/ui/agenda/VistaPorRecursos";
import VistaPorUnidades from "./components/ui/agenda/VistaPorUnidades";
import AdministrarRips from "./components/ui/settings/AdministrarRips";
import ConsecutivosRS from "./components/ui/settings/ConsecutivosRS";
import CiediezCliente from "./components/ui/settings/CiediezCliente";
import CupsCliente from "./components/ui/settings/CupsCliente";
import Configuracion from "./components/ui/general/Configuracion";
import EditarUsuario from "./components/ui/settings/Edit/EditarUsuario";
import CrearPaciente2 from "./components/ui/paciente/CrearPaciente2";
import CrearEmpresa from "./components/ui/paciente/CrearEmpresa";
import EditarEmpresaPaciente from "./components/ui/paciente/EditarEmpresa";
import ListarEmpresas from "./components/ui/paciente/ListarEmpresas";
import ParametrosRips from "./components/ui/settings/ParametrosRips";
import ConceptosEgresos from "./components/ui/settings/ConceptosEgresos";
import NuevoConceptoEgreso from "./components/ui/settings/NuevoConceptoEgreso";
import EditarConceptoEgreso from "./components/ui/settings/Edit/EditarConceptoEgreso";
import ParametrosFacturacion from "./components/ui/settings/ParametrosFacturacion";
import ParametrosNotaCredito from "./components/ui/settings/ParametrosNotaCredito";
import ParametrosModuloContable from "./components/ui/settings/ParametrosModuloContable";
import ParametrosFacturaNoElectronica from "./components/ui/settings/ParametrosFacturaNoElectronica";
import ParametrosEgreso from "./components/ui/settings/ParametrosEgreso";
import ConceptosPago from "./components/ui/settings/ConceptosPago";
import ConceptosFacturacion from "./components/ui/settings/ConceptosFacturacion";
import AgendaProfesional from "./components/ui/agenda/AgendaProfesional";
import Inicio from "./components/ui/general/Inicio";
import ListaCitasDia from "./components/ui/general/ListaCitasDia";
import ProtectedRoute from "./components/security/ProtectedRoute";
import ProfesionalRoute from "./components/security/ProfesionalRoute";
import ConfiguracionRDA from "./components/ui/settings/ConfiguracionRDA";
import ParametrosRDA from "./components/ui/settings/ParametrosRDA";
import ParametrosRDAUsuario from "./components/ui/settings/ParametrosRDAUsuario";
import CrearRDAExterna from "./components/ui/paciente/CrearRDAExterna";
import { RDA_UI_ENABLED } from "./config/featureFlags";


import CrearAgendas from "./components/ui/settings/CrearAgendas";
import NuevaAgenda from "./components/ui/settings/NuevaAgenda";
import EditarAgenda from "./components/ui/settings/Edit/EditarAgenda";
import ParametrosFev from "./components/ui/settings/ParametrosFev";
import NuevoParametroFev from "./components/ui/settings/NuevoParametroFev";
import EditarParametroFev from "./components/ui/settings/Edit/EditarParametroFev";
import Facturacion from "./components/ui/facturacion/Facturacion";
import MenuFacturacion from "./components/ui/facturacion/MenuFacturacion";
import ListarPacientesCartera from "./components/ui/facturacion/ListarPacientesCartera";
import ListadoPresupuestos from "./components/ui/facturacion/ListadoPresupuestos";
import CrearPresupuesto from "./components/ui/facturacion/CrearPresupuesto";
import EditarPresupuesto from "./components/ui/facturacion/EditarPresupuesto";
import ListadoFacturas from "./components/ui/facturacion/ListadoFacturas";
import CrearFactura from "./components/ui/facturacion/CrearFactura";
import CrearFacturaNoElectronica from "./components/ui/facturacion/CrearFacturaNoElectronica";
import EditarFactura from "./components/ui/facturacion/EditarFactura";
import VistaPreviaFactura from "./components/ui/facturacion/VistaPreviaFactura";
import VistaPreviaPresupuesto from "./components/ui/facturacion/VistaPreviaPresupuesto";
import VistaPreviaDocumentoSoporte from "./components/ui/facturacion/VistaPreviaDocumentoSoporte";
import VistaPreviaEgreso from "./components/ui/facturacion/VistaPreviaEgreso";
import InformacionDocumentoSoporte from "./components/ui/facturacion/InformacionDocumentoSoporte";
import InformacionFactura from "./components/ui/facturacion/InformacionFactura";
import LandingPage from "./components/landing/LandingPage";
import Indicadores from "./components/ui/general/Indicadores";
import AdministrarNotas from "./components/ui/general/AdministrarNotas";

// Superadmin Components
import LoginSuperadmin from "./components/ui/superadmin/LoginSuperadmin";
import DashboardSuperadmin from "./components/ui/superadmin/DashboardSuperadmin";
import ClientesLista from "./components/ui/superadmin/ClientesLista";
import ClienteInformacion from "./components/ui/superadmin/ClienteInformacion";
import ClienteForm from "./components/ui/superadmin/ClienteForm";
import UsuariosCliente from "./components/ui/superadmin/UsuariosCliente";
import UsuarioForm from "./components/ui/superadmin/UsuarioForm";
import PlantillasAdmin from "./components/ui/superadmin/PlantillasAdmin";
import CrearPlantillaAdmin from "./components/ui/superadmin/CrearPlantillaAdmin";
import EditarPlantillaAdmin from "./components/ui/superadmin/EditarPlantillaAdmin";
import CrearPlantillaSimpleAdmin from "./components/ui/superadmin/CrearPlantillaSimple";
import EditarPlantillaSimpleAdmin from "./components/ui/superadmin/EditarPlantillaSimple";
import AsignarPlantillaClientes from "./components/ui/superadmin/AsignarPlantillaClientes";
import ParametrosGlobales from "./components/ui/superadmin/ParametrosGlobales";
import ParametrosFevSuperadmin from "./components/ui/superadmin/ParametrosFev";
import WhatsappControl from "./components/ui/superadmin/WhatsappControl";
import SmsControl from "./components/ui/superadmin/SmsControl";
import ArchivosClinicosControl from "./components/ui/superadmin/ArchivosClinicosControl";
// Superadmin - Datos Maestros (con alias para evitar conflictos)
import EspecialidadesSuperadmin from "./components/ui/superadmin/Especialidades";
import NuevaEspecialidadSuperadmin from "./components/ui/superadmin/NuevaEspecialidad";
import EditarEspecialidadSuperadmin from "./components/ui/superadmin/EditarEspecialidad";
import CargosSuperadmin from "./components/ui/superadmin/Cargos";
import NuevoCargoSuperadmin from "./components/ui/superadmin/NuevoCargo";
import EditarCargoSuperadmin from "./components/ui/superadmin/EditarCargo";
import TiposContratoSuperadmin from "./components/ui/superadmin/TiposContrato";
import NuevoTipoContratoSuperadmin from "./components/ui/superadmin/NuevoTipoContrato";
import EditarTipoContratoSuperadmin from "./components/ui/superadmin/EditarTipoContrato";
import NoticiasSuperadmin from "./components/ui/superadmin/Noticias";
import NoticiaFormSuperadmin from "./components/ui/superadmin/NoticiaForm";
import ContraseñasUsuarios from "./components/ui/superadmin/ContraseñasUsuarios";
import RegistroRipsFev from "./components/ui/rips/RegistroRipsFev";
import ListadoRips from "./components/ui/rips/ListadoRips";
import RegistroRipsSinFev from "./components/ui/rips/RegistroRipsSinFev";
import RipsConvenios from "./components/ui/rips/RipsConvenios";
import CrearFacturaRips from "./components/ui/rips/CrearFacturaRips";
import AdministrarServiciosRips from "./components/ui/rips/AdministrarServiciosRips";
import ListadoDocumentosSoporte from "./components/ui/facturacion/ListadoDocumentosSoporte";
import AreasLocalizacion from "./components/ui/settings/AreasLocalizacion";
import ListadoTemperaturaHumedad from "./components/ui/indicadores/ListadoTemperaturaHumedad";
import FormularioTemperaturaHumedad from "./components/ui/indicadores/FormularioTemperaturaHumedad";
import CrearDocumentoSoporte from "./components/ui/facturacion/CrearDocumentoSoporte";
import ListarEgresos from "./components/ui/facturacion/ListarEgresos";
import CrearEgreso from "./components/ui/facturacion/CrearEgreso";



function App() {

  return (

    <Router basename={process.env.REACT_APP_ROUTER_BASENAME || '/'}>
      <Switch>


        <Route exact path="/">
          <LandingPage />
        </Route>

        <Route exact path="/login">
          <Login2 />
        </Route>

        <Route path="/new-user">
          <NewUser />
        </Route>

        {/* Ruta de registro comentada - Registro deshabilitado */}
        {/* <Route path="/signup">
          <Signup />
        </Route> */}

        <ProtectedRoute path="/home" component={Home}>
        </ProtectedRoute>

        <ProtectedRoute path="/lista-citas" component={ListaCitasDia}>
        </ProtectedRoute>

        <Route path="/logout">
          <Logout />
        </Route>

        <Route path="/request-password">
          <NewPassword />
        </Route>

        <Route path="/reset-password">
          <ResetPassword />
        </Route>

        <Route path="/activate-user">
          <ActivateUser />
        </Route>

        <Route path="/users">
          <Users />
        </Route>

        <ProtectedRoute path="/settings" component={Settings}>
        </ProtectedRoute>

        <ProtectedRoute path="/security" component={Security}>
        </ProtectedRoute>

        <Route path="/parametros-sistema">
          <ParametrosSistema />
        </Route>

        <ProtectedRoute path="/suscripcion-epayco" component={ParametrosSuscripcionEpayco}>
        </ProtectedRoute>

        <Route path="/parametros-whatsapp">
          <ParametrosWhatsapp />
        </Route>

        <ProtectedRoute path="/roles" component={Roles}>
        </ProtectedRoute>

        <ProtectedRoute path="/personal-proveedores" component={PersonalProveedores}>
        </ProtectedRoute>

        <ProtectedRoute path="/new-role" component={NewRole}>
        </ProtectedRoute>

        <ProtectedRoute path="/medios-publicitarios" component={MediosPublicitarios}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-medio-publicitario" component={NuevoMedioPublicitario}>
        </ProtectedRoute>

        <ProtectedRoute path="/aseguradoras" component={Aseguradoras}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-aseguradora" component={NuevaAseguradora}>
        </ProtectedRoute>

        <ProtectedRoute path="/convenios" component={Convenios}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-convenio" component={NuevoConvenio}>
        </ProtectedRoute>

        <ProtectedRoute path="/especialidades" component={Especialidades}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-especialidad" component={NuevaEspecialidad}>
        </ProtectedRoute>

        <ProtectedRoute path="/eps-empresas" component={EmpresasAseguradoras}>
        </ProtectedRoute>

        <ProtectedRoute path="/empresas" component={ListarEmpresas}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-empresa" component={NuevaEmpresa}>
        </ProtectedRoute>

        <ProtectedRoute path="/unidades-atencion" component={UnidadesAtencion}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-unidad-atencion" component={NuevaUnidadAtencion}>
        </ProtectedRoute>

        <ProtectedRoute path="/personal" component={Usuarios}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-usuario" component={NuevoUsuario}>
        </ProtectedRoute>

        <ProtectedRoute path="/cargos" component={Cargos}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-cargo" component={NuevoCargo}>
        </ProtectedRoute>

        <ProtectedRoute path="/tipos-contrato" component={TiposContrato}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-tipo-contrato" component={NuevoTipoContrato}>
        </ProtectedRoute>

        <ProtectedRoute path="/proveedores" component={Proveedores}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-proveedor" component={NuevoProveedor}>
        </ProtectedRoute>

        <ProtectedRoute path="/usuarios-sispro" component={UsuariosSispro}>
        </ProtectedRoute>

        <ProtectedRoute path="/nuevo-usuario-sispro" component={NuevoUsuarioSispro}>
        </ProtectedRoute>

        <ProtectedRoute path="/editar-usuario-sispro" component={EditarUsuarioSispro}>
        </ProtectedRoute>

        <ProtectedRoute path="/administrar-plantillas" component={AdministrarPlantillas}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-formulas" component={PlantillasFormulas}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-formula" component={NuevaPlantillaFormula}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-otros-documentos" component={PlantillasOtrosDocumentos}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-otro-documento" component={NuevaPlantillaOtroDocumento}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-examenes" component={PlantillasExamenes}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-examen" component={NuevaPlantillaExamen}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-recomendaciones" component={PlantillasRecomendaciones}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-recomendacion" component={NuevaPlantillaRecomendacion}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-eventos-adversos" component={PlantillasEventosAdversos}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-evento-adverso" component={NuevaPlantillaEventoAdverso}>
        </ProtectedRoute>

        <ProtectedRoute path="/plantillas-incapacidades" component={PlantillasIncapacidades}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-plantilla-incapacidad" component={NuevaPlantillaIncapacidad}>
        </ProtectedRoute>

        <Route path="/parametros-inventario">
          <ParametrosInventario />
        </Route>

        <Route path="/localizaciones-articulos">
          <LocalizacionesArticulos />
        </Route>

        <Route path="/nueva-localizacion-articulo">
          <NuevaLocalizacionArticulo />
        </Route>

        <Route path="/referencias-inventario">
          <ReferenciasInventario />
        </Route>

        <Route path="/nueva-referencia-inventario">
          <NuevaReferenciaInventario />
        </Route>

        <Route path="/plantillas-consentimientos">
          <PlantillasConsentimientos />
        </Route>

        <Route path="/nueva-plantilla-consentimiento">
          <NuevaPlantillaConsentimiento />
        </Route>

        <Route path="/especialidades-referencia">
          <EspecialidadesReferencia />
        </Route>

        <Route path="/administrar-tratamientos">
          <AdministrarTratamientos />
        </Route>

        <Route path="/parametros-fev">
          <ParametrosFev />
        </Route>

        {RDA_UI_ENABLED && (
        <Route path="/configuracion-rda">
          <ConfiguracionRDA />
        </Route>
        )}

        {RDA_UI_ENABLED && (
        <ProtectedRoute path="/parametros-rda" component={ParametrosRDA}>
        </ProtectedRoute>
        )}

        {RDA_UI_ENABLED && (
        <ProtectedRoute path="/parametros-rda-usuario" component={ParametrosRDAUsuario}>
        </ProtectedRoute>
        )}

        {RDA_UI_ENABLED && (
        <ProtectedRoute path="/crear-rda-externa" component={CrearRDAExterna}>
        </ProtectedRoute>
        )}

        <Route path="/nuevo-parametro-fev">
          <NuevoParametroFev />
        </Route>

        <Route path="/parametro-fev">
          <EditarParametroFev />
        </Route>

        <Route path="/menu-facturacion">
          <MenuFacturacion />
        </Route>

        <Route path="/estado-cuenta-pacientes">
          <ListarPacientesCartera />
        </Route>

        <Route path="/registrar-factura">
          <Facturacion />
        </Route>

        <Route path="/listado-presupuestos">
          <ListadoPresupuestos />
        </Route>

        <Route path="/crear-presupuesto">
          <CrearPresupuesto />
        </Route>

        <Route path="/editar-presupuesto/:id">
          <EditarPresupuesto />
        </Route>

        <Route path="/vista-previa-presupuesto/:id">
          <VistaPreviaPresupuesto />
        </Route>

        <Route path="/listado-facturas">
          <ListadoFacturas />
        </Route>

        <Route path="/crear-factura">
          <CrearFactura />
        </Route>

        <Route path="/crear-factura-no-electronica">
          <CrearFacturaNoElectronica />
        </Route>

        <Route path="/editar-factura/:id">
          <EditarFactura />
        </Route>

        <Route path="/vista-previa-factura/:id">
          <VistaPreviaFactura />
        </Route>

        <Route path="/vista-previa-documento-soporte/:id">
          <VistaPreviaDocumentoSoporte />
        </Route>

        <Route path="/vista-previa-egreso/:id">
          <VistaPreviaEgreso />
        </Route>

        <Route path="/informacion-documento-soporte/:id">
          <InformacionDocumentoSoporte />
        </Route>

        <Route path="/informacion-factura/:id">
          <InformacionFactura />
        </Route>

        <Route path="/registrar-factura">
          <CrearFactura />
        </Route>

        <Route path="/nueva-especialidad-referencia">
          <NuevaEspecialidadReferencia />
        </Route>

        <Route path="/parametros-evolucion">
          <ParametrosEvolucion />
        </Route>

        <Route path="/nuevo-parametro-evolucion">
          <NuevoParametroEvolucion />
        </Route>

        {/* COMENTADO: Parámetros Historia Clínica - Ya no se usa, se gestiona desde superadmin */}
        {/* <Route path="/parametros-historia-clinica">
          <ParametrosHistoriaClinica />
        </Route>

        <Route path="/nuevo-parametro-historia-clinica">
          <NuevoParametroHistoriaClinica />
        </Route> */}

        <Route path="/parametro-historia-clinica">
          <EditarParametroHistoriaClinica />
        </Route>

        <Route path="/listas-precios">
          <ListaPrecios />
        </Route>

        <Route path="/nueva-lista-precios">
          <NuevaListaPrecios />
        </Route>

        <ProtectedRoute path="/lista-precios-convenio" component={ListaPreciosConvenio}>
        </ProtectedRoute>

        <ProtectedRoute path="/administrar-convenios" component={AdministrarConvenios}>
        </ProtectedRoute>

        <ProtectedRoute path="/menu-pacientes" component={MenuPacientes}>
        </ProtectedRoute>

        <ProtectedRoute path="/menu-laboratorio" component={MenuLaboratorio}>
        </ProtectedRoute>

        <ProtectedRoute path="/listado-ordenes-laboratorio" component={ListarOrdenesLaboratorio}>
        </ProtectedRoute>

        <ProtectedRoute path="/crear-orden-laboratorio" component={CrearOrdenLaboratorio}>
        </ProtectedRoute>

        <ProtectedRoute path="/detalle-orden-laboratorio/:id" component={DetalleOrdenLaboratorio}>
        </ProtectedRoute>

        <ProtectedRoute path="/tipos-trabajo-laboratorio" component={TiposTrabajoLaboratorio}>
        </ProtectedRoute>

        <ProtectedRoute path="/materiales-laboratorio" component={MaterialesLaboratorio}>
        </ProtectedRoute>

        <Route path="/agendar-cita">
          <AgendarPaciente />
        </Route>

        <Route path="/parametros-agenda">
          <ParametrosAgenda />
        </Route>

        <ProtectedRoute path="/planes-agendamiento" component={PlanesAgendamiento}>
        </ProtectedRoute>

        <ProtectedRoute path="/plan-agendamiento" component={PlanAgendamientoForm}>
        </ProtectedRoute>

        <ProtectedRoute path="/paciente-planes-sesiones" component={PacientePlanesSesiones}>
        </ProtectedRoute>

        <Route path="/horario-atencion">
          <HorarioAtencion />
        </Route>


        <ProtectedRoute path="/crear-agendas" component={CrearAgendas}>
        </ProtectedRoute>

        <ProtectedRoute path="/nueva-agenda" component={NuevaAgenda}>
        </ProtectedRoute>

        <Route path="/editar-agenda">
          <EditarAgenda />
        </Route>







        <Route path="/estados-cita">
          <EstadosCita />
        </Route>

        <Route path="/pacientes">
          <ListarPacientes />
        </Route>

        <Route path="/estado-cuenta-paciente">
          <EstadoCuentaPaciente />
        </Route>

        <Route path="/listar-citas">
          <ListarCitas />
        </Route>

        <Route path="/aseguradora">
          <EditarAseguradora />
        </Route>

        <Route path="/empresa">
          <EditarEmpresa />
        </Route>

        <Route path="/convenio">
          <EditarConvenio />
        </Route>

        <Route path="/parametro-evolucion">
          <EditarParametroEvolucion />
        </Route>

        <Route path="/plantilla-formula">
          <EditarFormulaMedica />
        </Route>

        <ProtectedRoute path="/plantilla-otro-documento" component={EditarOtroDocumento}>
        </ProtectedRoute>

        <Route path="/plantilla-examen">
          <EditarPlantillaExamenLaboratorio />
        </Route>

        <Route path="/plantilla-incapacidad">
          <EditarPlantillaIncapacidades />
        </Route>

        <Route path="/plantilla-evento-adverso">
          <EditarPlantillaEventosAdversos />
        </Route>

        <Route path="/plantilla-consentimiento">
          <EditarPlantillaConsentimiento />
        </Route>

        <Route path="/localizacion-articulo">
          <EditarAreaLocalizacion />
        </Route>

        <Route path="/referencia-inventario">
          <EditarReferenciaInventario />
        </Route>

        <Route path="/especialidad">
          <EditarEspecialidad />
        </Route>

        <Route path="/proveedor">
          <EditarProveedor />
        </Route>

        <Route path="/unidad-atencion">
          <EditarUnidadAtencion />
        </Route>

        <Route path="/cargo">
          <EditarCargo />
        </Route>

        <Route path="/tipo-contrato">
          <EditarTipoContrato />
        </Route>

        <Route path="/lista-precio">
          <EditarListaPrecios />
        </Route>

        <Route path="/especialidad-referencia">
          <EditarEspecialidadReferencia />
        </Route>

        <Route path="/medio-publicitario">
          <EditarMedioPublicitario />
        </Route>

        <Route path="/estado-cita">
          <EditarEstadoCita />
        </Route>

        <Route path="/perfil">
          <Perfil2 />
        </Route>

        <Route path="/set-password">
          <SetPassword />
        </Route>

        <Route path="/loading">
          <Loading />
        </Route>

        <ProtectedRoute path="/setup-cuenta" component={ClientForm}>
        </ProtectedRoute>

        <Route path="/editar-rol">
          <EditarRol />
        </Route>

        <ProtectedRoute path="/editar-paciente" component={EditarPaciente}>
        </ProtectedRoute>

        <Route path="/bloqueos-agenda">
          <BloqueosAgenda />
        </Route>

        <Route path="/nuevo-bloqueo">
          <NuevoBloqueo />
        </Route>

        <ProfesionalRoute path="/evolucion-paciente" component={EvolucionPaciente}>
        </ProfesionalRoute>

        <ProfesionalRoute path="/historia-clinica-json" component={HistoriaClinicaJsonPage}>
        </ProfesionalRoute>

        <ProtectedRoute path="/atender-paciente" component={AtenderPaciente}>
        </ProtectedRoute>

        <ProtectedRoute path="/ayudas-diagnosticas" component={AyudasDiagnosticasPaciente}>
        </ProtectedRoute>

        <ProfesionalRoute path="/toxina-botulinica" component={ToxinaBotulinica}>
        </ProfesionalRoute>

        <Route path="/cuestionario-paciente">
          <CuestionarioPaciente1 />
        </Route>

        <Route path="/cuestionario-paciente2">
          <CuestionarioPaciente2 />
        </Route>

        <Route path="/cuestionario-paciente3">
          <CuestionarioPaciente3 />
        </Route>

        <Route path="/cuestionario-paciente4">
          <CuestionarioPaciente4 />
        </Route>

        <Route path="/confirmacion-cuestionario">
          <ConfirmacionCuestionario />
        </Route>

        <Route path="/tiempos-cita">
          <TiemposCita />
        </Route>

        <Route path="/nuevo-tiempo-cita">
          <NuevoTiempoCita />
        </Route>

        <Route path="/cuenta">
          <CuentaForm />
        </Route>

        <ProtectedRoute path="/cambio-clave" component={CambioClave}>
        </ProtectedRoute>

        <ProtectedRoute path="/agenda-dashboard" component={AgendaDashboard}>
        </ProtectedRoute>

        <ProtectedRoute path="/agenda" component={AgendaGeneral}>
        </ProtectedRoute>

        <Route path="/otras-plantillas">
          <OtrasPlantillas />
        </Route>

        <Route path="/nueva-plantilla">
          <NuevaPlantilla />
        </Route>

        <Route path="/plantilla-recomendacion">
          <EditarPlantillaRecomendaciones />
        </Route>

        <Route path="/bloqueo">
          <EditarBloqueo />
        </Route>

        <Route path="/otra-plantilla">
          <EditarPlantillaOtras />
        </Route>

        <Route path="/tiempo-cita">
          <EditarTiempoCita />
        </Route>

        <Route path="/nuevo-precio-convenio">
          <NuevoPrecioConvenio />
        </Route>

        <Route path="/editar-precio-convenio">
          <EditarPrecioConvenio />
        </Route>

        <Route path="/estadisticas">
          <Estadisticas />
        </Route>

        <Route path="/estadisticas-contables">
          <EstadisticasContables />
        </Route>

        <Route path="/reportes-agenda">
          <ReportesAgenda />
        </Route>

        <ProtectedRoute path="/reporte-pacientes" component={ReportePacientes}>
        </ProtectedRoute>

        <ProtectedRoute path="/estado-cuenta-reportes" component={EstadoCuentaReportes}>
        </ProtectedRoute>

        <Route path="/busqueda-citas">
          <BusquedaCitas />
        </Route>

        <Route path="/citas-canceladas">
          <CitasCanceladas />
        </Route>

        <Route path="/bloqueos-unidades">
          <BloqueosUnidades />
        </Route>

        <Route path="/control-asistencia">
          <ControlAsistencia />
        </Route>

        <Route path="/nuevo-bloqueo-unidad">
          <NuevoBloqueoUnidad />
        </Route>

        <Route path="/bloqueo-unidad">
          <EditarBloqueoUnidad />
        </Route>

        <Route path="/estadisticas-agenda">
          <EstadisticasAgenda />
        </Route>

        <Route path="/agenda-recursos">
          <VistaPorRecursos />
        </Route>


        <ProtectedRoute path="/reporte-facturacion" component={ReporteFacturacion}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-notas-credito" component={ReporteNotasCredito}>
        </ProtectedRoute>

        <ProtectedRoute path="/liquidaciones-profesional" component={ListadoLiquidacionProfesional}>
        </ProtectedRoute>

        <ProtectedRoute path="/liquidar-profesional" component={ReporteLiquidarProfesional}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-presupuestos-aprobados" component={ReportePresupuestosAprobados}>
        </ProtectedRoute>

        <ProtectedRoute path="/libro-diario" component={LibroDiario}>
        </ProtectedRoute>

        <ProtectedRoute path="/facturas-recibos" component={ReporteFacturasRecibos}>
        </ProtectedRoute>

        <ProtectedRoute path="/documentos-egresos" component={ReporteDocumentosEgresos}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-documentos-soporte" component={ReporteDocumentosSoporte}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-egresos" component={ReporteEgresos}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-tratamientos-facturados" component={ReporteTratamientosFacturados}>
        </ProtectedRoute>

        <ProtectedRoute path="/reporte-tratamientos-facturados-paciente" component={ReporteTratamientosFacturadosPaciente}>
        </ProtectedRoute>

        <ProtectedRoute path="/exportar-siigo" component={ExportarSiigo}>
        </ProtectedRoute>

        <Route path="/agenda-unidades">

          <VistaPorUnidades />
        </Route>

        <Route path="/indicadores">
          <Indicadores />
        </Route>

        <Route path="/administrar-notas">
          <AdministrarNotas />
        </Route>

        <Route path="/listado-rips">
          <ListadoRips />
        </Route>

        <Route path="/rips-convenios">
          <RipsConvenios />
        </Route>

        <Route path="/crear-factura-rips">
          <CrearFacturaRips />
        </Route>

        <Route path="/administrar-rips">
          <AdministrarRips />
        </Route>

        <Route path="/administrar-servicios-rips">
          <AdministrarServiciosRips />
        </Route>

        <Route path="/areas-localizacion">
          <AreasLocalizacion />
        </Route>

        <Route path="/registros-temperatura-humedad">
          <ListadoTemperaturaHumedad />
        </Route>

        <Route path="/crear-registro-temperatura-humedad">
          <FormularioTemperaturaHumedad />
        </Route>

        <Route path="/editar-registro-temperatura-humedad/:id">
          <FormularioTemperaturaHumedad />
        </Route>

        <Route path="/consecutivos-rs">
          <ConsecutivosRS />
        </Route>

        <Route path="/ciediez">
          <CiediezCliente />
        </Route>

        <Route path="/cups">
          <CupsCliente />
        </Route>

        <Route path="/configuracion">
          <Configuracion />
        </Route>

        <Route path="/editar-usuario">
          <EditarUsuario />
        </Route>

        <ProtectedRoute path="/crear-paciente" component={CrearPaciente2}>
        </ProtectedRoute>

        <ProtectedRoute path="/crear-empresa" component={CrearEmpresa}>
        </ProtectedRoute>

        <ProtectedRoute path="/editar-empresa" component={EditarEmpresaPaciente}>
        </ProtectedRoute>

        <ProtectedRoute path="/listar-empresas" component={ListarEmpresas}>
        </ProtectedRoute>

        <Route path="/parametros-rips">
          <ParametrosRips />
        </Route>

        <Route path="/conceptos-egresos">
          <ConceptosEgresos />
        </Route>

        <Route path="/nuevo-concepto-egreso">
          <NuevoConceptoEgreso />
        </Route>

        <Route path="/concepto-egreso">
          <EditarConceptoEgreso />
        </Route>

        <Route path="/parametros-facturacion">
          <ParametrosFacturacion />
        </Route>

        <Route path="/parametros-nota-credito">
          <ParametrosNotaCredito />
        </Route>

        <Route path="/parametros-modulo-contable">
          <ParametrosModuloContable />
        </Route>

        <Route path="/parametros-factura-no-electronica">
          <ParametrosFacturaNoElectronica />
        </Route>
        <Route path="/parametros-egreso">
          <ParametrosEgreso />
        </Route>

        <Route path="/conceptos-pago">
          <ConceptosPago />
        </Route>

        <Route path="/conceptos-facturacion">
          <ConceptosFacturacion />
        </Route>

        <Route path="/agenda-profesional">
          <AgendaProfesional />
        </Route>

        <Route path="/inicio">
          <Inicio />
        </Route>

        <Route path="/registro-rips-fev">
          <RegistroRipsFev />
        </Route>

        <Route path="/registro-rips-sin-fev">
          <RegistroRipsSinFev />
        </Route>

        <Route path="/menu-facturacion">
          <MenuFacturacion />
        </Route>

        <Route path="/estado-cuenta-pacientes">
          <ListarPacientesCartera />
        </Route>

        <Route path="/listado-facturas">
          <ListadoFacturas />
        </Route>

        <Route path="/crear-factura">
          <CrearFactura />
        </Route>

        <Route path="/crear-factura-no-electronica">
          <CrearFacturaNoElectronica />
        </Route>

        <Route path="/informacion-factura/:id">
          <InformacionFactura />
        </Route>

        <Route path="/listado-presupuestos">
          <ListadoPresupuestos />
        </Route>

        <Route path="/crear-presupuesto">
          <CrearPresupuesto />
        </Route>

        <Route path="/listado-documentos-soporte">
          <ListadoDocumentosSoporte />
        </Route>

        <Route path="/crear-documento-soporte">
          <CrearDocumentoSoporte />
        </Route>

        <Route path="/listado-egresos">
          <ListarEgresos />
        </Route>

        <Route path="/crear-egreso">
          <CrearEgreso />
        </Route>

        <ProtectedRoute path="/plantillas-historia-clinica-json" component={PlantillasHistoriaClinica}>
        </ProtectedRoute>

        <ProtectedRoute path="/asignar-plantillas-historia-clinica" component={AsignarPlantillas}>
        </ProtectedRoute>

        {/* Rutas de Superadmin */}
        <Route exact path="/superadmin/login">
          <LoginSuperadmin />
        </Route>

        <Route exact path="/superadmin/dashboard">
          <DashboardSuperadmin />
        </Route>

        <Route exact path="/superadmin/clientes">
          <ClientesLista />
        </Route>

        <Route exact path="/superadmin/clientes/nuevo">
          <ClienteForm />
        </Route>

        <Route exact path="/superadmin/clientes/editar/:id">
          <ClienteForm />
        </Route>

        <Route exact path="/superadmin/clientes/:clienteId/informacion">
          <ClienteInformacion />
        </Route>

        <Route exact path="/superadmin/clientes/:clienteId/usuarios">
          <UsuariosCliente />
        </Route>

        <Route exact path="/superadmin/clientes/:clienteId/usuarios/nuevo">
          <UsuarioForm />
        </Route>

        <Route exact path="/superadmin/usuarios/editar/:id">
          <UsuarioForm />
        </Route>

        <Route exact path="/superadmin/plantillas">
          <PlantillasAdmin />
        </Route>

        <Route exact path="/superadmin/plantillas/crear">
          <CrearPlantillaAdmin />
        </Route>

        <Route exact path="/superadmin/plantillas/editar/:id">
          <EditarPlantillaAdmin />
        </Route>

        <Route exact path="/superadmin/plantillas/crear-simple">
          <CrearPlantillaSimpleAdmin />
        </Route>

        <Route exact path="/superadmin/plantillas/editar-simple/:id">
          <EditarPlantillaSimpleAdmin />
        </Route>

        <Route exact path="/superadmin/plantillas/:id/asignar">
          <AsignarPlantillaClientes />
        </Route>

        <Route exact path="/superadmin/parametros">
          <ParametrosGlobales />
        </Route>

        <Route exact path="/superadmin/parametros-fev">
          <ParametrosFevSuperadmin />
        </Route>

        {/* Superadmin - Especialidades */}
        <Route exact path="/superadmin/especialidades">
          <EspecialidadesSuperadmin />
        </Route>

        <Route exact path="/superadmin/especialidades/nueva">
          <NuevaEspecialidadSuperadmin />
        </Route>

        <Route exact path="/superadmin/especialidades/editar/:id">
          <EditarEspecialidadSuperadmin />
        </Route>

        {/* Superadmin - Cargos */}
        <Route exact path="/superadmin/cargos">
          <CargosSuperadmin />
        </Route>

        <Route exact path="/superadmin/cargos/nuevo">
          <NuevoCargoSuperadmin />
        </Route>

        <Route exact path="/superadmin/cargos/editar/:id">
          <EditarCargoSuperadmin />
        </Route>

        {/* Superadmin - Tipos de Contrato */}
        <Route exact path="/superadmin/tipos-contrato">
          <TiposContratoSuperadmin />
        </Route>

        <Route exact path="/superadmin/tipos-contrato/nuevo">
          <NuevoTipoContratoSuperadmin />
        </Route>

        <Route exact path="/superadmin/tipos-contrato/editar/:id">
          <EditarTipoContratoSuperadmin />
        </Route>

        {/* Superadmin - Noticias */}
        <Route exact path="/superadmin/noticias">
          <NoticiasSuperadmin />
        </Route>

        <Route exact path="/superadmin/noticias/nueva">
          <NoticiaFormSuperadmin />
        </Route>

        <Route exact path="/superadmin/noticias/editar/:id">
          <NoticiaFormSuperadmin />
        </Route>

        {/* Superadmin - WhatsApp Control */}
        <Route exact path="/superadmin/whatsapp">
          <WhatsappControl />
        </Route>

        <Route exact path="/superadmin/sms">
          <SmsControl />
        </Route>

        <Route exact path="/superadmin/archivos-clinicos">
          <ArchivosClinicosControl />
        </Route>

        <Route exact path="/superadmin/contrasenas-usuarios">
          <ContraseñasUsuarios />
        </Route>

      </Switch>
    </Router>
  );
}

export default App;